import { ObjectValues } from '../../app/types/utilityTypes';

export const LID_EVENT_TYPES = {
  NONE: 0,
  AIRES_FILE_UPLOAD: 1,
  ENRICHMENT_BUSINESS_ADDRESS: 2,
  NCUA_WORKBOOK_UPDATE: 3,
  REPROCESS_SUBMISSION: 4,
  NCUA_WORKBOOK_UPDATE_OUTDATED: 5,
  AIRES_PLUS_FILE_UPLOAD: 6,
  AIRES_FILE_UPLOAD_AND_CUSTOM_FLAGS: 7,
  AIRES_PLUS_FILE_UPLOAD_AND_CUSTOM_FLAGS: 8,
  ENRICHMENT_COLLEGE_STUDENT: 9,
} as const;

export type LidEventType = ObjectValues<typeof LID_EVENT_TYPES>;
